// Path: ./src/app/pages/CreateFlyerItemPage/CreateFlyerModal/styled.ts
import type { CSSProperties } from "react";
import styled from "styled-components";
import { TextInputField } from "../../../../utils/commonStyledComponents/commonStyled";

export const InheritTextInputField = styled(TextInputField)`
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 10px;
`;

export const InheritTextInputFieldV2 = styled(InheritTextInputField)`
  max-width: 160px;
`;

export const Card = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: 15px 16px 15px 16px;
  min-height: 541px;
`;

export const CardItem = styled.div`
  position: relative;
  background-color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 210;
  @media (max-width: 768px) {
    flex-direction: column;
    width: 100%;
  }
`;

export const LeftSideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width: 293px;
  margin: auto;
  @media (max-width: 768px) {
    width: 100%;
    align-items: stretch;
  }
`;

export const ImageCardWrapper = styled.div`
  position: relative;
  width: 293px;
  height: 470px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ImageEditButton = styled.div`
  position: absolute;
  bottom: 8px;
  right: 8px;
  opacity: 0;
  transition: opacity 0.3s;
  ${ImageCardWrapper}:hover & {
    opacity: 1;
  }
`;

export const ImageTagButton = styled.div`
  position: absolute;
  bottom: 8px;
  right: 56px;
  opacity: 0;
  transition: opacity 0.3s;
  ${ImageCardWrapper}:hover & {
    opacity: 1;
  }
`;

export const ImageCard = styled.img`
  height: 470px;
  width: 293px;
  border-radius: 10px;
  box-shadow: 0px 5px 5px 0px #8888886b;
  object-fit: contain;
  object-position: center;
  background-color: #8080804a;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ImageCardEmpty = styled.div`
  height: 470px;
  width: 293px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ImageSubTitle = styled.div`
  padding: 4px;
  margin-top: 8px;
  font-size: 12px;
  text-transform: CAPITALIZE;
  width: 293px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  background: #fff;
  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const Button = styled.div<{ $disabled?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 4px 14px;
  border: 2px solid #ff8038;
  border-radius: 6px;
  transition: all 0.3s;
  white-space: nowrap;
  :hover {
    background-color: ${(props) =>
      props.$disabled ? "transparent" : "#ff8038"};
    color: ${(props) => (props.$disabled ? "inherit" : "white")};
  }
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
  width: 100%;
`;

interface LocalButtonProps {
  htmlFor?: string;
  $disabled?: boolean;
}
export const LocalButton = styled.label<LocalButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 4px 14px;
  border: 2px solid #ff8038;
  border-radius: 6px;
  transition: all 0.3s;
  white-space: nowrap;
  :hover {
    background-color: ${(props) =>
      props.$disabled ? "transparent" : "#ff8038"};
    color: ${(props) => (props.$disabled ? "inherit" : "white")};
  }
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
  width: 100%;
`;
export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-top: 4px;
  column-gap: 6px;
`;

export const imageActionButtonStyles: CSSProperties = {
  width: "100%",
  minHeight: "33px",
  padding: "2px 8px",
  fontSize: "14px",
  fontWeight: 500,
  lineHeight: 1.2,
};
export const SyncUpdateHeader = styled.div`
  width: 100%;
  text-align: left;
  color: #ff8038;
  margin-top: 5px;
  margin-bottom: 0;
  padding: 8px 10px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.3px;
  background: linear-gradient(135deg, #fff8f5 0%, #fff 100%);
  border: 1px solid #e0e0e0;
  border-bottom: none;
  border-radius: 4px 4px 0 0;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: #ff8038;
    box-shadow: 0 1px 4px rgba(255, 128, 56, 0.1);
  }

  &:hover + div {
    border-color: #ff8038;
    box-shadow: 0 1px 4px rgba(255, 128, 56, 0.1);
  }
`;
export const CheckBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  margin-top: 0;
  padding: 6px;
  border-radius: 0 0 4px 4px;
  border: 1px solid #e0e0e0;
  gap: 4px;
  width: 100%;

  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  transition: all 0.2s ease-in-out;

  &:hover {
    background-color: #f5f5f5;
    border-color: #ff8038;
    box-shadow: 0 1px 4px rgba(255, 128, 56, 0.1);
  }

  ${SyncUpdateHeader}:has(+ &:hover) {
    border-color: #ff8038;
    box-shadow: 0 1px 4px rgba(255, 128, 56, 0.1);
  }

  & > div {
    padding: 4px 6px;
    border-radius: 3px;
    background-color: white;
    border: 1px solid #e8e8e8;
    transition: all 0.2s ease-in-out;

    &:hover {
      border-color: #ff8038;
      background-color: #fff8f5;
      box-shadow: 0 1px 4px rgba(255, 128, 56, 0.1);
    }

    .MuiFormControlLabel-root {
      margin: 0;
      width: 100%;

      .MuiFormControlLabel-label {
        flex: 1;
        display: flex;
        align-items: center;
        font-weight: 400;
        color: #333;
        font-size: 12px;

        & > div {
          display: flex;
          align-items: center;
          gap: 3px;
          width: 100%;

          span {
            flex: 1;
          }
        }
      }
    }

    .MuiCheckbox-root {
      padding: 4px;

      &.Mui-checked {
        .MuiSvgIcon-root {
          filter: drop-shadow(0 1px 1px rgba(255, 128, 56, 0.2));
        }
      }
    }
  }

  @media (max-width: 768px) {
    margin-top: 6px;
    padding: 4px;

    & > div {
      padding: 3px 4px;
    }
  }
`;

export const RightSideWrapper = styled.div`
  padding-left: 16px;
  margin: auto;
  width: 100%;
  @media (max-width: 1199px) {
    width: 100%;
    margin: 0px;
    margin-top: 30px;
  }
  @media (max-width: 768px) {
    padding-left: 0;
    margin-top: 16px;
  }
`;
export const RightSideTitle = styled.div``;
export const SalesSectionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: start;
`;
export const PriceWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 10px;
  width: 100%;

  @media (max-width: 509px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const UnitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  @media (max-width: 509px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const BottomSection = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  @media (max-width: 509px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const BottomLeftWrapper = styled.div`
  width: 100%;
`;

export const BottomRightWrapper = styled.div``;

export const DotDotDivider = styled.div`
  border: none;
  border-top: 1px dotted grey;
  color: #fff;
  background-color: #fff;
  height: 1px;
  width: 100%;
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const SubmitButton = styled.div`
  width: 100%;
  min-width: 100px;
  background-color: #ff8038;
  height: 36px;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  cursor: pointer;
  padding: 0 20px;
  font-size: 14px;
  @media (max-width: 509px) {
    height: 36px;
    padding: 0 15px;
    margin-top: 8px;
  }
`;

export const RegularPrice = styled.div``;
export const RegularPriceTitle = styled.div``;
export const LimitInput = styled.input`
  width: 100%;
  max-width: 150px;
  padding: 8px;
  border: 1px solid #dedede;
  outline-color: #dedede;
  border-radius: 4px;
  font-size: 16px;
  caret-color: #fd954f;

  :hover {
    outline-color: #fd954f;
    border-color: #fd954f;
  }
`;

export const LimitWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 10px;
`;
export const SmallImageWrapper = styled.div`
  width: 100%;
`;
export const MultipleImages = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  align-content: start;
  min-height: 470px;
  height: 100%;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 8px 10px;
  max-height: 470px;
  box-sizing: border-box;
`;
export const ImageLoaderWrapper = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 300px;
`;

export const RankPriceRemarksWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  column-gap: 10px;
  width: 100%;

  @media (max-width: 509px) {
    flex-direction: column;
    align-items: start;
  }
`;

export const RankPriceRemarksWrapperV2 = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  column-gap: 10px;
  width: 100%;

  @media (max-width: 509px) {
    flex-direction: column;
    align-items: start;
    row-gap: 15px;
  }
`;

export const RemoveBgButton = styled.button<{ $disabled?: boolean }>`
  margin-top: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  border: 2px solid #ff8038;
  border-radius: 6px;
  padding: 6px 14px;
  transition: all 0.3s;
  background-color: white;
  :hover {
    background-color: ${(props) => (props.$disabled ? "white" : "#ff8038")};
    color: ${(props) => (props.$disabled ? "inherit" : "white")};
  }
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.$disabled ? "none" : "auto")};
  &:disabled {
    background-color: #ffc49c;
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SalePriceContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 240px;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`;

export const Label = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;

  .MuiSwitch-root {
    padding: 6px;
  }
  .MuiSwitch-thumb {
    width: 12px;
    height: 12px;
  }
  .MuiSwitch-track {
    border-radius: 12px;
  }
`;

export const FrontPageCheckboxWrapper = styled.div`
  width: 100%;
  margin-top: 5px;
  padding: 6px 10px;
  background: linear-gradient(135deg, #fffbf8 0%, #fff 100%);
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;

  &:hover {
    border-color: #ff8038;
    background: linear-gradient(135deg, #fff8f5 0%, #fff 100%);
    box-shadow: 0 1px 3px rgba(255, 128, 56, 0.08);
  }

  .MuiFormControlLabel-root {
    margin: 0;
    width: 100%;

    .MuiFormControlLabel-label {
      font-size: 12px;
      font-weight: 500;
      color: #444;
      letter-spacing: 0.2px;

      & > div {
        display: flex;
        align-items: center;
        gap: 4px;

        span {
          flex: 1;
        }
      }
    }
  }

  .MuiCheckbox-root {
    padding: 4px;
    margin-right: 4px;

    &.Mui-checked {
      .MuiSvgIcon-root {
        filter: drop-shadow(0 0.5px 1px rgba(255, 128, 56, 0.3));
      }
    }

    .MuiSvgIcon-root {
      font-size: 18px;
    }
  }
`;
